import React from "react";
import { Input, type InputProps } from "@/components/ui/Input";

type BankDetailsNumberFieldProps = Omit<InputProps, "onChange"> & {
  onChange: (value: string) => void;
  maxLength?: number;
  ref?: React.Ref<HTMLInputElement>;
};

export function BankDetailsNumberField(props: BankDetailsNumberFieldProps) {
  const { onChange, maxLength, ...inputProps } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    const numericValue = Number.parseFloat(value);

    if (Number.isNaN(numericValue)) {
      onChange("");
      return;
    }

    if (maxLength && value.length > maxLength) {
      onChange(value.slice(0, maxLength));
      return;
    }

    onChange(value);
  };

  return <Input onChange={(event) => handleChange(event)} {...inputProps} />;
}
